import { SET_LAST_SUB_MENU } from '../actions/menu';

const initialState = {
  lastUid: '',
  lastId: 0,
};

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LAST_SUB_MENU:
      return {
        ...state,
        lastUid: action.payload.lastUid,
        lastId: action.payload.lastId,
      };
    default:
      return state;
  }
};

export default menuReducer;
